// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {getDefaultState} from '../state';

const resetShowSelectAll = () => getDefaultState().showSelectAll;

const updateShowSelectAll = (state, action) => action.showSelectAll;

export default (state = getDefaultState().showSelectAll, action) => {

    const actionTypes = {
        [actions.RESET_ADVANCED_CLAIM_SUMMARY_SHOW_SELECT_ALL]: resetShowSelectAll,
        [actions.UPDATE_ADVANCED_CLAIM_SUMMARY_SHOW_SELECT_ALL]: updateShowSelectAll
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/reducers/show-select-all.js